var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f86a6a;}.cls-2{fill:#ffe3e3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_786",
    "data-name": "Group 786"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1685",
    "data-name": "Rectangle 1685",
    className: "cls-1",
    width: 7,
    height: 28
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_743",
    "data-name": "Group 743"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1764",
    "data-name": "Rectangle 1764",
    className: "cls-2",
    x: 2.5,
    y: 9,
    width: 2,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1765",
    "data-name": "Rectangle 1765",
    className: "cls-2",
    x: 2.5,
    y: 17,
    width: 2,
    height: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.fdbd3a8ae8fd2025a5dcf608f5741fbc.svg";
export { ForwardRef as ReactComponent };